export default __webpack_public_path__ + "static/media/jo.c630a519.svg";